import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";

import AdminShell from "@/pages/admin/AdminShell";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminTenants from "@/pages/admin/AdminTenants";
import AdminPlans from "@/pages/admin/AdminPlans";
import AdminCoupons from "@/pages/admin/AdminCoupons";

import OwnerShell from "@/pages/owner/OwnerShell";
import OwnerDashboard from "@/pages/owner/OwnerDashboard";
import Vehicles from "@/pages/owner/Vehicles";
import Drivers from "@/pages/owner/Drivers";
import Clients from "@/pages/owner/Clients";
import Bookings from "@/pages/owner/Bookings";
import Trips from "@/pages/owner/Trips";
import Fuel from "@/pages/owner/Fuel";
import Expenses from "@/pages/owner/Expenses";
import Reports from "@/pages/owner/Reports";
import Billing from "@/pages/owner/Billing";
import Settings from "@/pages/owner/Settings";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />

            <Route
              path="/admin"
              element={<ProtectedRoute role="super_admin"><AdminShell /></ProtectedRoute>}
            >
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="tenants" element={<AdminTenants />} />
              <Route path="plans" element={<AdminPlans />} />
              <Route path="coupons" element={<AdminCoupons />} />
            </Route>

            <Route
              path="/app"
              element={<ProtectedRoute role="tenant"><OwnerShell /></ProtectedRoute>}
            >
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<OwnerDashboard />} />
              <Route path="bookings" element={<Bookings />} />
              <Route path="trips" element={<Trips />} />
              <Route path="vehicles" element={<Vehicles />} />
              <Route path="drivers" element={<Drivers />} />
              <Route path="clients" element={<Clients />} />
              <Route path="fuel" element={<Fuel />} />
              <Route path="expenses" element={<Expenses />} />
              <Route path="reports" element={<Reports />} />
              <Route path="billing" element={<Billing />} />
              <Route path="settings" element={<Settings />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
